const MediaTypes = {
  Website: 1,
  Video: 2,
  PDF: 3,
}

export default MediaTypes
